import { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

export default function BeneficiariesCard({ beneficiaries = [], onSend }) {
  const [open, setOpen] = useState(false);

  // show only latest 2 in card
  const visibleBeneficiaries = beneficiaries.slice(0, 2);

  const BeneficiaryRow = (b, i) => (
    <Box
      key={i}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px solid #e6e9ef",
        borderRadius: 2,
        p: 2,
        mb: 2,
      }}
    >
      <Box display="flex" gap={2}>
        <Avatar>{b.ReceiverName?.[0]}</Avatar>
        <Box>
          <Typography fontWeight={600}>{b.ReceiverName}</Typography>
          <Typography fontSize={12} color="#7a7f87">
            {b.ReceiverMobilenumber}
          </Typography>
        </Box>
      </Box>

      <Typography
        fontSize={13}
        fontWeight={700}
        color="#1dbf73"
        sx={{ cursor: "pointer" }}
        onClick={() => {
          onSend?.(b.ReceiverMobilenumber);
          setOpen(false); // close popup if open
        }}
      >
        SEND
      </Typography>
    </Box>
  );

  return (
    <>
      {/* ===== MAIN CARD ===== */}
      <Paper sx={{ p: 3, borderRadius: 3, border: "1px solid #e6e9ef", mb: 3 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography fontWeight={600}>Registered Beneficiries</Typography>
          <Typography
            fontSize={13}
            fontWeight={600}
            color="#1dbf73"
            sx={{ cursor: "pointer" }}
            onClick={() => setOpen(true)}
          >
            View All
          </Typography>
        </Box>

        {visibleBeneficiaries.map(BeneficiaryRow)}
      </Paper>

      {/* ===== VIEW ALL POPUP ===== */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>All Beneficiaries</DialogTitle>
        <DialogContent>
          {beneficiaries.length > 0 ? (
            beneficiaries.map(BeneficiaryRow)
          ) : (
            <Typography fontSize={14} color="text.secondary">
              No beneficiaries found
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
